// Renderiza UMA caixa-d'água
import tanqueImg from "../../../../assets/img/CaixaDagua.png";
import "./renderCaixa.css";

export default function RenderCaixa({ desc, niveis = {} }) {
  // se algum campo faltar, assume false
  const {
    extravasao = false,
    normal     = false,
    baixo      = false,
  } = niveis;

  // Verifica quais níveis existem no objeto niveis
  const hasExtravasao = 'extravasao' in niveis;
  const hasNormal = 'normal' in niveis;
  const hasBaixo = 'baixo' in niveis;

  return (
    <div className="card">
      <div className="tankWrapper">
        <img src={tanqueImg} alt={desc} className="tankImg" />

        {hasExtravasao && (
          <div className={`level ${extravasao ? "alto" : ""}`}>Extravasão</div>
        )}
        
        {hasNormal && (
          <div className={`level ${normal ? "normal" : ""}`}>Normal</div>
        )}
        
        {hasBaixo && (
          <div className={`level ${baixo ? "baixo" : ""}`}>Baixo</div>
        )}
      </div>

      <h2 className="caption">{desc}</h2>
    </div>
  );
}